export default "/images/sidebar-1.jpg?fa66a345935416aca946585200630599";